import { useIntl } from "react-intl";

import { LoggedInConfluenceBlueWaveTemplate } from "../../components";

export const LoggedInConfluencePremium = () => {
    const { formatMessage } = useIntl();
    return (
        <LoggedInConfluenceBlueWaveTemplate
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudPremium",
                defaultMessage: "Cloud Premium"
            })}
        />
    );
};
